<template>
  <div>
    <h3>上传版本</h3>
    <el-form class="modifyForm" ref="modifyForm" :model="modifyForm" :rules="modifyRule" label-width="40%">

      <el-form-item label="productModel" prop="productModel">
        <template>
          <el-select v-model="modifyForm.productModel" placeholder="请选择productCode" @change="getmodifyFormproductCode">
            <el-option
              v-for="item in productList"
              :key="item.productModel"
              :label="item.productName"
              :value="item.productModel">
              <span style="float: left">{{ item.productName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.productModel }}</span>
            </el-option>
          </el-select>
        </template>
      </el-form-item>

      <el-form-item label="productCode" prop="productCode">
        <el-input :disabled="true" style="width: 300px;" v-model="modifyForm.productCode" placeholder="请输入productCode"
          @keyup.enter.native="modifyHandle()"></el-input>
      </el-form-item>


      <el-form-item label="version" prop="version">
        <el-input style="width: 300px;" v-model="modifyForm.version" placeholder="请输入version"
          @keyup.enter.native="modifyHandle()"></el-input>
      </el-form-item>

      <el-form-item label="verName" prop="verName">
        <el-input style="width: 300px;" v-model="modifyForm.verName" placeholder="请输入verName"
          @keyup.enter.native="modifyHandle()"></el-input>
      </el-form-item>

      <el-form-item label="verDesc" prop="verDesc">
        <el-input style="width: 300px;" v-model="modifyForm.verDesc" placeholder="请输入verDesc"
          @keyup.enter.native="modifyHandle()"></el-input>
      </el-form-item>


      <el-form-item>
        <input type="file" class="file" ref="upload" />
      </el-form-item>

      <el-form-item>
        <el-button style="width: 300px;" type="primary" @click="modifyHandle()">确 定</el-button>
      </el-form-item>

    </el-form>
    <hr />
    <br />
    <br />
    <h3>创建升级任务</h3>
    <el-form class="modifyForm2" ref="modifyForm2" :model="modifyForm2" :rules="modifyRule2" label-width="40%">


      <el-form-item label="请选择升级类型">
        <template>
          <el-select v-model="modifyForm2.taskType" placeholder="请选择" @change="getOtaType">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-form-item>

      <el-form-item label="流水号" prop="serialNum">
        <el-input style="width: 300px;" v-model="modifyForm2.serialNum" placeholder="请输入流水号"
          @keyup.enter.native="modifyHandle2()"></el-input>
      </el-form-item>


      <el-form-item label="设备ID" prop="devID">
        <el-input style="width: 300px;" v-model="modifyForm2.devID" placeholder="请输入设备ID"
          @keyup.enter.native="modifyHandle2()"></el-input>
      </el-form-item>



      <el-form-item label="srcVersion" prop="srcVersion">
        <el-input style="width: 300px;" v-model="modifyForm2.srcVersion" placeholder="请输入srcVersion"
          @keyup.enter.native="modifyHandle2()"></el-input>
      </el-form-item>

      <el-form-item label="dstVersion" prop="dstVersion">
        <el-input style="width: 300px;" v-model="modifyForm2.dstVersion" placeholder="请输入dstVersion"
          @keyup.enter.native="modifyHandle2()"></el-input>
      </el-form-item>

      <el-form-item label="productCode" prop="productCode">
        <template>
          <el-select v-model="modifyForm2.productCode" placeholder="请选择productCode" @change="getmodifyForm2productCode">
            <el-option
              v-for="item in productList"
              :key="item.productCode"
              :label="item.productName"
              :value="item.productCode">
              <span style="float: left">{{ item.productName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.productCode }}</span>
            </el-option>
          </el-select>
        </template>
      </el-form-item>

      <el-form-item label="taskDesc" prop="taskDesc">
        <el-input style="width: 300px;" v-model="modifyForm2.taskDesc" placeholder="请输入taskDesc"
          @keyup.enter.native="modifyHandle2()"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button style="width: 300px;" type="primary" @click="modifyHandle2()">确 定</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>



<script>
  import '../assets/css/ApartmentManagement.css'
  export default {
    data() {
      return {
        dataListLoading: false,
        modifyDialog: false,

        dataList: [],
        productList:[],

        modifyForm: {
          productCode: '',
          productModel: '',
          version: '1.0.1',
          verName: '1.0.1',
          verDesc: '1.0.1'
        },
        modifyForm2: {
          serialNum: '0000-0000', // 流水号
          devID: '0', // 设备ID
          srcVersion: '1.0.1',
          dstVersion: '1.0.2',
          productCode: '',
          taskDesc: '1.0.2',
          taskType:'1',
        },

        options: [{
                  value: '1',
                  label: '指定产品型号升级任务'
                }, {
                  value: '2',
                  label: '指定流水号升级任务'
                }, {
                  value: '4',
                  label: '指定设备id升级任务'
                }],


        modifyRule: {
          productCode: [{
            required: true,
            message: 'productCode不能为空',
            trigger: 'blur'
          }, ],
          version: [{
            required: true,
            message: 'version不能为空',
            trigger: 'blur'
          }, ],
          verName: [{
            required: true,
            message: 'verName不能为空',
            trigger: 'blur'
          }, ],
          verDesc: [{
            required: true,
            message: 'verDesc不能为空',
            trigger: 'blur'
          }, ],
          productModel: [{
            required: true,
            message: 'productModel不能为空',
            trigger: 'blur'
          }, ]
        },
        modifyRule2: {
          srcVersion: [{
            required: true,
            message: 'srcVersion不能为空',
            trigger: 'blur'
          }, ],
          dstVersion: [{
            required: true,
            message: 'dstVersion不能为空',
            trigger: 'blur'
          }, ],
          productCode: [{
            required: true,
            message: 'productCode不能为空',
            trigger: 'blur'
          }, ],
          taskDesc: [{
            required: true,
            message: 'taskDesc不能为空',
            trigger: 'blur'
          }, ]
        },

      }
    },

    created() {
      this.getProductListList();
    },
    methods: {
      // 清空上传文件
      reset() {
        // let self = this
        // Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      },
      // 清空升级任务
      reset2() {
        // let self = this
        // Object.keys(self.modifyForm2).forEach((key) => (self.modifyForm2[key] = ''))
      },

      // 上传升级文件
      modifyHandle() {

        console.log('productCode:',this.modifyForm.productCode)
        console.log('mode:',this.modifyForm.productModel)
        console.log('code:',this.modifyForm.productCode)
        if (!this.modifyForm.productCode || !this.modifyForm.productModel || !this.modifyForm.version || !this
          .modifyForm.verName || !this.modifyForm.verDesc) {
          this.$message.error('请输入有效升级参数')
          return;
        }

        let myfile = this.$refs.upload
        let files = myfile.files

        if (files.length == 0) {
          this.$message.error('请选择文件')
          return;
        }


        let file = files[0]

        var self = this;
        let param = new FormData() //formdata格式

        param.append('versionFile', file) //图片文件

        param.append('tenantCode', sessionStorage.getItem('tenantCode'))
        param.append('productCode', self.modifyForm.productCode)
        param.append('productModel', self.modifyForm.productModel)
        // param.append('productModel', '820301001400')
        param.append('version', self.modifyForm.version)
        param.append('verName', self.modifyForm.verName)
        param.append('verDesc', self.modifyForm.verDesc)


        console.log('param:',param);

        self.$axios
          ._UploadVersion(param)
          .then((res) => {
            console.log('上传固件版本:', res)
            const datas = res.data
            if (datas.code == 0) {
              self.reset()
              self.$message.success('创建成功')
            } else {
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.error('系统异常，请联系管理员')
          })

      },

      getOtaType(){
        console.log(this.modifyForm2.taskType);
      },
      getmodifyFormproductCode(){
          console.log(this.modifyForm.productModel)
          for(var i=0;i<this.productList.length;i++){
            var obj = this.productList[i];
            if(obj.productModel == this.modifyForm.productModel){
              this.modifyForm.productCode = obj.productCode;
            }
          }
      },
      getmodifyForm2productCode(){
        console.log(this.modifyForm2.productCode)
      },

      // 创建升级任务
      modifyHandle2() {

        if (!this.modifyForm2.srcVersion || !this.modifyForm2.dstVersion || !this.modifyForm2.productCode || !this
          .modifyForm2.taskDesc) {
          this.$message.error('请输入有效升级参数')
          return;
        }

        var self = this;
        let param = new FormData()
        param.append('srcVersion', self.modifyForm2.srcVersion)
        param.append('dstVersion', self.modifyForm2.dstVersion)
        param.append('tenantCode', sessionStorage.getItem('tenantCode'))
        param.append('productCode', self.modifyForm2.productCode)
        param.append('taskDesc', self.modifyForm2.taskDesc)
        param.append('taskType', self.modifyForm2.taskType)
        param.append('devId', self.modifyForm2.devID)
        param.append('serialNum', self.modifyForm2.serialNum)

        console.log('param-self.modifyForm2.taskType:',self.modifyForm2.taskType);
        console.log('param-self.modifyForm2.devID:',self.modifyForm2.devID);
        console.log('param-self.modifyForm2.serialNum:',self.modifyForm2.serialNum);

        self.$axios
          ._upOTA(param)
          .then((res) => {
            const datas = res.data
            console.log('data:', datas);
            if (datas.code == 0) {
              self.reset2()
              self.$message.success('创建成功')
            } else {
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.error('系统异常，请联系管理员')
          })

      },


    getProductListList() {
      let formdata = {
        tenantCode: sessionStorage.getItem('tenantCode'),
      }
      let self = this;
      self.$axios
        ._getProductList(formdata)
        .then((res) => {
          const datas = res.data
          console.log('获取产品类型', datas.data.content);

          if (datas.code == 0) {
            self.productList = datas.data.content
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
      self.dataListLoading = false
    },
    },
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/FirmwareManagement.vue